<template>
	<div id="productsServices">
		<h2 class="h2top">PRODUCTS ADN SERVICES</h2>
		<h2 class="h2bottom">产品及服务</h2>
		<div class="lineClass" style="height:2px;width: 16vw;margin: 0px 41.8% 5vw"></div>
		<div class="productsServicesbg">
			<img class="productsServicesbgimg" v-lazy="'../../static/img/01.jpg'" alt="">
		</div>
	</div>
</template>

<script>
export default {
data () {
return {}
},
created () {},
mounted () {}
}
</script>
<style scoped>
#productsServices{
	margin-top: 5vw;
}
.productsServicesbg{
	width: 100%;
	/* height: 1000px; */
	/* background-image: url("../../static/img/products&servicesone.png"); */
	/* background-size: 100% auto; */
	/* background-repeat: no-repeat; */
	position: relative;
	/* height: auto !important; */
}
.productsServicesbgimg{
	width:100%;
}
.boxTop{
	position: absolute;
	top:34%;
	right:22%;
	width: 24%;
	color: #343434;
}
.boxTop p{
	width: 90%;
	letter-spacing: 2px;
	margin: 10% 0;
}
.boxBottom{
	position: absolute;
	top:56%;
	right:22%;
	width: 24%;
	display: flex;
}
.box{
	/* background-color: pink; */
	flex: 1;
}
.QRcode{
	width:80%;
	/* height: 170px; */
	position: relative;
	display: inline-block;
}
.QRcode:after{
	content: '中运卡行货主端';
	position: absolute;
	bottom:-30px;
	left:2px;
	text-align: center;
	display: block;
	width:100%;
	font-size: 20px;
}
.QRcodesj:after{
	content: '中运卡行司机端';
}
.boxDownload{
	margin-left: 20px;
	display: inline-block;
	vertical-align: top;
	width:54%;
}
.boxDownload li{
	width:100%;
	height: 74px;
	background-color: #419EFF;
	border-radius: 37px;
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
}
.boxDownload li img{
	width: 33px;
	height: 36px;
	margin-right: 10px;
}
.boxDownload li span{
	font-size: 26px;
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/products&services.vue